/**
 * instant.page-style HTML prefetch on hover (the "bagaggio" pattern).
 *
 * A single delegated listener warms the browser prefetch cache AND the
 * Cloudflare edge cache by injecting `<link rel="prefetch" as="document">`
 * ~250ms after the cursor lands on an internal link. Navigation stays a plain
 * full-document `<a>` load (NOT SPA) — the prefetch just makes the click feel
 * instant on a cache HIT.
 *
 * Kept as a plain string constant (not a `useScript(fn)` serialization) so SSR
 * and client builds emit byte-identical markup — no hydration mismatch.
 *
 * SPA links carry `data-spa` and are skipped here: the router already prefetches
 * their loader data, so a full-document prefetch would be wasted.
 */
export const HTML_PREFETCH_SCRIPT = `(function(){
  if(typeof window==="undefined"||typeof document==="undefined")return;
  var DELAY=250;
  var done=new Set();
  var timer=null;
  var conn=navigator.connection;
  if(conn&&(conn.saveData||/(^|-)2g$/.test(conn.effectiveType||"")))return;
  function eligible(a){
    if(!a||a.tagName!=="A")return false;
    if(a.hasAttribute("data-spa"))return false;
    if(a.hasAttribute("data-no-prefetch"))return false;
    if(a.hasAttribute("download"))return false;
    if(a.target&&a.target!==""&&a.target!=="_self")return false;
    var href=a.getAttribute("href");
    if(!href||href.charCodeAt(0)!==47||href.charCodeAt(1)===47)return false;
    var url=a.href;
    try{if(new URL(url).origin!==location.origin)return false;}catch(e){return false;}
    if(done.has(url))return false;
    return true;
  }
  function prefetch(url){
    if(done.has(url))return;
    done.add(url);
    var l=document.createElement("link");
    l.rel="prefetch";
    l.as="document";
    l.href=url;
    document.head.appendChild(l);
  }
  function over(e){
    var t=e.target;
    var a=t&&t.closest?t.closest("a[href]"):null;
    if(!eligible(a))return;
    var url=a.href;
    clearTimeout(timer);
    timer=setTimeout(function(){prefetch(url);},DELAY);
  }
  function out(){clearTimeout(timer);}
  document.addEventListener("pointerover",over,{passive:true});
  document.addEventListener("pointerout",out,{passive:true});
  document.addEventListener("focusin",over,{passive:true});
  document.addEventListener("touchstart",function(e){
    var t=e.target;
    var a=t&&t.closest?t.closest("a[href]"):null;
    if(eligible(a))prefetch(a.href);
  },{passive:true});
})();`;
